module.exports = __webpack_public_path__ + "1.5.0-unryo/img/varnish.ca96de76.svg";